import { get, set, del } from 'idb-keyval';

export const STORE_KEY = `react-query-cache-v1`;

export const indexedDbPersister = {
  persistClient: async (client) => {
    try {
      await set(STORE_KEY, client);
    } catch {
      try {
        await del(STORE_KEY);
      } catch {
        // IndexedDB may be unavailable; let React Query continue without persistence.
      }
    }
  },
  restoreClient: async () => {
    try {
      return await get(STORE_KEY);
    } catch {
      return undefined;
    }
  },
  removeClient: async () => {
    await del(STORE_KEY);
  },
};
